/*
 * @Author: Chen Zhen
 * @LastEditors: Nie Wie
 * @Description: 控制器按钮
 * @Date: 2019-03-22 17:07:12
 * @LastEditTime: 2020-03-26 16:14:27
 */

/* eslint-disable no-underscore-dangle */

import zrender from 'zrender'
import _ from 'lodash'

import { DEFAULT_COLOR } from './timeline.conf'

const DEFAULT_SIZE = 10

// TODO 在播放按钮加对应的功能

class Arrow {
  constructor({
    size = DEFAULT_SIZE,
    position = [ 20, 20 ],
    arrow = Math.PI / 2,
    placeholderSize,
    handleClick,
  }) {
    this.size = size // 大小
    this.position = position
    this.arrow = arrow
    this.handleClick = handleClick

    this.placeholderSize = placeholderSize

    this.zrender = null

    this.init()

    return this
  }

  init() {
    this.zrender = new zrender.Group()

    if (this.placeholderSize > 0) {
      this.placeholder = this._getPlaceholder()
      this.zrender.add(this.placeholder) // 用于放大点击面积
    }

    this.zrender.add(this.getArrow())

    if (_.isFunction(this.handleClick)) {
      this.zrender.on('click', this.handleClick)
    } else {
      throw new RangeError('handleClick must a function')
    }
  }

  getArrow() {
    return new zrender.Polyline({
      style: {
        stroke: DEFAULT_COLOR,
        lineWidth: 2,
      },
      shape: {
        points: this.getPoints(),
      },
    })
  }

  // eslint-disable-next-line class-methods-use-this
  getPoints() {
    return [
      [ 10, 20 ],
      [ 20, 20 ],
      [ 20, 10 ],
    ]
  }

  _getPlaceholder() {
    const halfSize = this.placeholderSize / 2
    return new zrender.Polyline({
      style: {
        fill: 'rgba(0,0,0,0)',
        lineWidth: 0,
      },
      // silent: true,
      shape: {
        points: [
          [ this.position[0] - halfSize, this.position[1] + halfSize ],
          [ this.position[0] + halfSize, this.position[1] + halfSize ],
          [ this.position[0] + halfSize, this.position[1] - halfSize ],
          [ this.position[0] - halfSize, this.position[1] - halfSize ],
        ],
      },
    })
  }
}

// 左按钮
export class ArrowLeft extends Arrow {
  getPoints() {
    const widthHelf = Math.cos(this.arrow / 2) * this.size / 2
    const heightHelf = Math.sin(this.arrow / 2) * this.size

    return [
      [ this.position[0] + widthHelf, this.position[1] - heightHelf ],
      [ this.position[0] - widthHelf, this.position[1] ],
      [ this.position[0] + widthHelf, this.position[1] + heightHelf ],
    ]
  }
}
// 右按钮
export class ArrowRight extends Arrow {
  getPoints() {
    const widthHelf = Math.cos(this.arrow / 2) * this.size / 2
    const heightHelf = Math.sin(this.arrow / 2) * this.size

    return [
      [ this.position[0] - widthHelf, this.position[1] - heightHelf ],
      [ this.position[0] + widthHelf, this.position[1] ],
      [ this.position[0] - widthHelf, this.position[1] + heightHelf ],
    ]
  }
}
// 上按钮
export class ArrowTop extends Arrow {
  getPoints() {
    const widthHelf = Math.cos(this.arrow / 2) * this.size
    const heightHelf = Math.sin(this.arrow / 2) * this.size / 2

    return [
      [ this.position[0] + widthHelf, this.position[1] + heightHelf ],
      [ this.position[0], this.position[1] - heightHelf ],
      [ this.position[0] - widthHelf, this.position[1] + heightHelf ],
    ]
  }
}
// 下按钮
export class ArrowBottom extends Arrow {
  getPoints() {
    const widthHelf = Math.cos(this.arrow / 2) * this.size / 2
    const heightHelf = Math.sin(this.arrow / 2) * this.size

    return [
      [ this.position[0] - heightHelf, this.position[1] - widthHelf ],
      [ this.position[0], this.position[1] + widthHelf ],
      [ this.position[0] + heightHelf, this.position[1] - widthHelf ],
    ]
  }
}

// 播放按钮
export class PlayButton {
  constructor({
    size = DEFAULT_SIZE,
    position = [ 20, 20 ],
    status = 'stop',
    handleClick,
  }) {
    this.size = size
    this.position = position
    this.handleClick = handleClick

    this.status = status

    this.zrender = null
    this.playButton = null
    this.stopButtons = null

    this.init()

    return this
  }

  init() {
    this.zrender = new zrender.Group()

    // 一个圆圈
    const circle = new zrender.Circle({
      style: {
        fill: 'transparent',
        // stroke: DEFAULT_COLOR,
        stroke: null,
        lineWidth: 2,
      },
      // silent: true,
      shape: {
        cx: this.position[0],
        cy: this.position[1],
        r: this.size,
      },
    })

    this.zrender.add(circle)

    const _playSize = this.size / 2
    const tan30 = Math.tan(Math.PI / 6)
    const sin60 = Math.sin(Math.PI / 3)

    this.playButton = new zrender.Polygon({
      style: {
        fill: '#215AFF',
      },
      shape: {
        points: [
          [ this.position[0] - tan30 * _playSize, this.position[1] - _playSize ],
          [ this.position[0] + _playSize / sin60, this.position[1] ],
          [ this.position[0] - tan30 * _playSize, this.position[1] + _playSize ],
        ],
      },
    })

    const _stopDiffHeight = this.size / 3
    const _stopDiffWidth = this.size / 4

    this.stopButtons = [
      new zrender.Line({
        style: {
          fill: 'transparent',
          stroke: '#215AFF',
          lineWidth: 2,
        },
        shape: {
          x1: this.position[0] - _stopDiffWidth,
          y1: this.position[1] - _stopDiffHeight,
          x2: this.position[0] - _stopDiffWidth,
          y2: this.position[1] + _stopDiffHeight,
        },
      }),
      new zrender.Line({
        style: {
          fill: 'transparent',
          stroke: DEFAULT_COLOR,
          lineWidth: 2,
        },
        shape: {
          x1: this.position[0] + _stopDiffWidth,
          y1: this.position[1] - _stopDiffHeight,
          x2: this.position[0] + _stopDiffWidth,
          y2: this.position[1] + _stopDiffHeight,
        },
      }),
    ]

    this.initButton()
    // 根据当前的情况进行显示不同的icon

    if (_.isFunction(this.handleClick)) {
      this.zrender.on('click', () => {
        this.handleClick(this.status)
      })
    } else {
      throw new RangeError('handleClick must a function')
    }
  }

  changeStatus(status) {
    this.status = status

    this.changeButton()
  }

  /**
   * 初始化新增按钮
   */
  initButton() {
    this.changeButton(true)
  }

  /**
   * 根据当前的状态改变按钮
   */
  changeButton(isFirst = false) {
    const fun = {
      stop: () => {
        if (!isFirst) {
          this.zrender.remove(this.stopButtons[0])
          this.zrender.remove(this.stopButtons[1])
        }

        this.zrender.add(this.playButton)
      },
      play: () => {
        if (!isFirst) {
          this.zrender.remove(this.playButton)
        }

        this.zrender.add(this.stopButtons[0])
        this.zrender.add(this.stopButtons[1])
      },
    }

    const _fun = fun[this.status]

    if (_.isFunction(_fun)) {
      _fun()
    } else {
      throw new Error('错误的status属性', this.status)
    }
  }
}

